import React from 'react';

// Actual JK Metal Product Images from src/assets/jk-metal-images
import tinIngot1 from '../assets/jk-metal-images/Tin Ingot/1.jpg';
import tinIngot2 from '../assets/jk-metal-images/Tin Ingot/2.jpg';
import tinIngot3 from '../assets/jk-metal-images/Tin Ingot/3.jpg';

import leadIngot4 from '../assets/jk-metal-images/Lead Ingot/4.jpg';
import leadIngot5 from '../assets/jk-metal-images/Lead Ingot/5.jpg';
import leadMetal21 from '../assets/jk-metal-images/Lead Metal/21.jpg';

import copperAxe10 from '../assets/jk-metal-images/Copper Axe/10.jpg';
import copperAxe11 from '../assets/jk-metal-images/Copper Axe/11.jpg';
import copperAxe9 from '../assets/jk-metal-images/Copper Axe/9.jpg';

import solderWire8 from '../assets/jk-metal-images/Solder Wire/8.jpg';
import solderStick14 from '../assets/jk-metal-images/Solder Stick/14.jpg';
import solderStick15 from '../assets/jk-metal-images/Solder Stick/15.jpg';

import solderBar22 from '../assets/jk-metal-images/Solder Bar/22.jpg';
import solderBar23 from '../assets/jk-metal-images/Solder Bar/23.jpg';
import solderIngot16 from '../assets/jk-metal-images/Solder Ingot/16.jpg';
import solderIngot17 from '../assets/jk-metal-images/Solder Ingot/17.jpg';
import solderRoundChaka from '../assets/jk-metal-images/Solder Round Chaka/27.jpg';

import zincIngot from '../assets/jk-metal-images/Zinc/Zinc Ingot.jpg';

export const DummyProductImage = ({ 
  title = "Industrial Metal", 
  category = "Metal Alloy", 
  type = "tin", 
  image = null 
}) => {
  // Map specific product names or types to the real company images
  const getImage = () => {
    if (image) return image;
    
    const lowerTitle = (title || "").toLowerCase();
    const lowerCategory = (category || "").toLowerCase();

    // Zinc
    if (lowerTitle.includes("zinc")) return zincIngot;

    // Copper
    if (lowerTitle.includes("copper axe")) return copperAxe10;
    if (lowerTitle.includes("copper") || type === "copper") return copperAxe9;

    // Solder Wire
    if (lowerTitle.includes("wire") || lowerTitle.includes("spool")) return solderWire8;

    // Solder Stick
    if (lowerTitle.includes("star") || lowerTitle.includes("stick")) return solderStick14;

    // Solder Bar / Ingot / Round Chaka
    if (lowerTitle.includes("round") || lowerTitle.includes("chaka")) return solderRoundChaka;
    if (lowerTitle.includes("small solder") || lowerTitle.includes("solder ingot")) return solderIngot16;
    if (lowerTitle.includes("long solder") || lowerTitle.includes("solder bar")) return solderBar22;
    if (lowerTitle.includes("solder paste")) return solderBar23;

    // Lead Ingot / Lead Metal
    if (lowerTitle.includes("lead metal")) return leadMetal21;
    if (lowerTitle.includes("lead") || type === "lead") return leadIngot4;

    // Tin Ingot
    if (lowerTitle.includes("tin") || type === "tin") return tinIngot1;

    // Category fallbacks
    if (lowerCategory.includes("copper")) return copperAxe10;
    if (lowerCategory.includes("solder")) return solderStick14;
    if (lowerCategory.includes("ingot")) return tinIngot1;

    return tinIngot1;
  };

  const selectedImg = getImage();

  return (
    <div className="product-real-img-container" style={{
      width: "100%",
      height: "240px",
      borderRadius: "12px 12px 0 0",
      position: "relative",
      overflow: "hidden",
      backgroundColor: "#06182c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <img 
        src={selectedImg} 
        alt={title} 
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transition: "transform 0.5s ease"
        }}
        className="product-catalog-img"
      />

      {/* Category Badge Pill */}
      <span style={{
        position: "absolute",
        top: "12px",
        left: "12px",
        background: "rgba(6, 24, 44, 0.85)",
        backdropFilter: "blur(6px)",
        color: "#38bdf8",
        fontSize: "11px",
        fontWeight: "700",
        padding: "4px 10px",
        borderRadius: "20px",
        border: "1px solid rgba(56, 189, 248, 0.4)",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        zIndex: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
      }}>
        {category}
      </span>
    </div>
  );
};

export default DummyProductImage;
